import { qsStringify, Backend, isVkPlay } from '@vkplay/shared';
import api from "@utils/api";

export const state = {
  sections: {
    isLoading: false,
    data: {},
    error: null,
  },
  document: {
    isLoading: false,
    data: {},
    error: null,
  },
  contents: {
    isLoading: false,
    data: {},
    error: null,
  },
  currency: {
    isLoading: false,
    data: {},
    error: null,
  },
  tax: {
    isLoading: false,
    data: {},
    error: null,
  }
};

export const mutations = {
  SET_SECTIONS(state, payload) {
    state.sections.data = payload;
    state.sections.error = null;
  },
  SET_CONTENTS(state, payload) {
    state.contents.data = payload;
    state.contents.error = null;
  },
  SET_DOCUMENT(state, payload) {
    state.document.data = payload;
    state.document.error = null;
  },
  SET_STATE_LOADING(state, { key, value }) {
    state[key].isLoading = value;
  },
  SET_ERROR(state, { key, value }) {
    state[key].error = value;
  },
  SET_CURRENCY(state, payload) {
    state.currency.data = payload;
    state.currency.error = null;
  },
  SET_TAX(state, payload) {
    state.tax.data = payload;
    state.tax.error = null;
  },
};

export const actions = {
  async fetchSections({ commit }) {
    commit('SET_STATE_LOADING', {
      key: 'sections',
      value: true,
    });

    await api.get('/v1/')
      .then((res) => {
        commit('SET_SECTIONS', res);
      })
      .catch((e) => {
        commit('SET_ERROR', {
          key: 'sections',
          value: e,
        });
      })
      .finally(() => {
        commit('SET_STATE_LOADING', {
          key: 'sections',
          value: false,
        });
      });
  },
  async fetchContents({ commit }, params) {
    commit('SET_STATE_LOADING', {
      key: 'contents',
      value: true,
    });

    try {
      let url = '/v1/';

      if (params.projectSlug) {
        url += `${params.projectSlug}/`;
      }

      const data = await api.get(url);

      commit('SET_CONTENTS', data);
    } catch (error) {
      commit('SET_ERROR', {
        key: 'contents',
        value: error,
      });
    } finally {
      commit('SET_STATE_LOADING', {
        key: 'contents',
        value: false,
      });
    }
  },
  async fetchDocument({ commit }, params) {
    commit('SET_STATE_LOADING', {
      key: 'document',
      value: true,
    });

    try {
      let url = '/v1/';

      if (params.projectSlug) {
        url += `${params.projectSlug}/`;
      }

      if (params.documentSlug) {
        url += `${params.documentSlug}/`;
      }

      const stringifiedParams = qsStringify({
        lang: params?.query?.lang || undefined,
        tag: params?.query?.tag || undefined,
        ts: params?.query?.ts || undefined,
      }, {
        addQueryPrefix: true,
      });

      if (stringifiedParams.length > 0) {
        url += stringifiedParams;
      }

      const data = await api.get(url);

      commit('SET_DOCUMENT', data);
    } catch (error) {
      commit('SET_ERROR', {
        key: 'document',
        value: error,
      });
    } finally {
      commit('SET_STATE_LOADING', {
        key: 'document',
        value: false,
      });
    }
  },
  async fetchCurrency({ commit }, params) {
    if (!params.date) {
      return;
    }

    commit('SET_STATE_LOADING', {
      key: 'currency',
      value: true,
    });

    const formatDate = `${params.date.getFullYear()}-${params.date.getMonth() + 1}-${params.date.getDate()}`;

    await Backend.get(`https://${isVkPlay ? 'api.vkplay.ru' : 'api.my.games'}/play/currency_rate/?date=${formatDate}`)
      .then((res) => {
        commit('SET_CURRENCY', res);
      })
      .catch((e) => {
        commit('SET_ERROR', {
          key: 'currency',
          value: e,
        });
      })
      .finally(() => {
        commit('SET_STATE_LOADING', {
          key: 'currency',
          value: false,
        });
      });
  },
  async fetchTax({ commit }, params) {
    commit('SET_STATE_LOADING', {
      key: 'tax',
      value: true,
    });

    await Backend.get(`https://${isVkPlay ? 'api.vkplay.ru' : 'api.my.games'}/play/vat_vals/?lang=${params.locale}`)
      .then((res) => {
        commit('SET_TAX', res.result);
      })
      .catch((e) => {
        commit('SET_ERROR', {
          key: 'tax',
          value: e,
        });
      })
      .finally(() => {
        commit('SET_STATE_LOADING', {
          key: 'tax',
          value: false,
        });
      });
  }
};

export const getters = {
  getterSections(state) {
    return state.sections;
  },
  getterContents(state) {
    return state.contents;
  },
  getterDocument(state) {
    return state.document;
  },
  getterCurrency(state) {
    return state.currency;
  },
  getterTax(state) {
    return state.tax;
  },
};
